// Will move all the favourite related store here in the future development
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	likeCount: 0
};

export const favouriteSlice = createSlice({
	name: 'favouritePage',
	initialState,
	reducers: {
		incrementLikeCountByOne: (state) => {
			state.likeCount += 1;
		},
		decrementLikeCountByOne: (state) => {
			state.likeCount -= 1;
		},
		resetLikeCount: (state) => {
			state.likeCount = 0;
		}
	}
});

export const { incrementLikeCountByOne, decrementLikeCountByOne, resetLikeCount } = favouriteSlice.actions;

export default favouriteSlice.reducer;
